// extracted by mini-css-extract-plugin
export default {"topBar":"TrainingLogoBar_topBar__DW-ju","logo":"TrainingLogoBar_logo__8g4gD"};